import { createTheme } from "@mui/material/styles";

export const AppTheme = createTheme({
  palette: {
    background: {
      default: "#fafafa"
    },
    primary: {
      main: "#0081c7",
    },
    secondary: {
      main: "#ee7f00",
    },
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          textAlign: "left",
        },
      },
    },
  },
});
